import { LitElement, html, css } from 'lit'
import { StoreMixin } from '../store.js'

class AppRoot extends StoreMixin(LitElement) {
  static styles = css`
    :host { display: block; min-height: 100vh; }
    main { max-width: 1120px; margin: 0 auto; padding: 2.5rem 2.5rem 4.5rem; }
    @media (max-width: 620px) { main { padding: 1.5rem 1.25rem 3rem; } }
  `

  render() {
    const { user } = this.appState
    return html`
      ${user ? html`<app-nav></app-nav>` : ''}
      <main><app-router></app-router></main>
      <app-toast></app-toast>
    `
  }
}

customElements.define('app-root', AppRoot)
